// src/pages/ContabilidadFinanzasPage.js (MIGRADO A REACT ROUTER)
import React, { useState } from 'react';
// 🛑 IMPORTACIÓN DE useNavigate
import { FiArrowLeft, FiChevronDown, FiChevronUp, FiDollarSign, FiBarChart2, FiBookOpen } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom'; // ✅ Importado
import '../styles/ServicesCommon.css'; 
import './ContabilidadFinanzasStyles.css'; 

// Componente reutilizable para el contenido desplegable (Acordeón)
const AccordionItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="accordion-item">
            <button className="accordion-title" onClick={() => setIsOpen(!isOpen)}>
                {title}
                {isOpen ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
            </button>
            {isOpen && <div className="accordion-content">{children}</div>}
        </div>
    );
};

// Datos de ejemplo (Placeholder)
const CONTABILIDAD_FINANZAS_SECTIONS = [
    {
        category: "Servicios Contables y de Auditoría",
        icon: <FiBookOpen size={22} />,
        items: [
            {
                title: "Contabilidad General y Libros Contables",
                content: `Gestión completa de la contabilidad, registro de transacciones, y mantenimiento de libros contables de acuerdo con las normativas venezolanas para personas naturales y jurídicas.`,
            },
            {
                title: "Auditoría Financiera y Fiscal",
                content: `Revisión exhaustiva de estados financieros y cumplimiento de obligaciones fiscales para garantizar transparencia y evitar sanciones.`,
            },
            {
                title: "Declaraciones de Impuestos y Deberes Formales",
                content: `Preparación y presentación de declaraciones de IVA, ISLR y otros impuestos nacionales y municipales.`,
            },
        ]
    },
    {
        category: "Asesoría Financiera y Tributaria",
        icon: <FiDollarSign size={22} />,
        items: [
            {
                title: "Planificación Tributaria Estratégica",
                content: `Desarrollo de estrategias legales para optimizar la carga fiscal y maximizar los beneficios de la empresa, siempre en cumplimiento con la ley.`,
            },
            {
                title: "Análisis de Costos y Presupuestos",
                content: `Determinación precisa de costos de producción y operación, y elaboración de presupuestos financieros detallados para una mejor toma de decisiones.`,
            },
            {
                title: "Elaboración de Flujos de Caja y Proyecciones",
                content: `Análisis de la liquidez y proyección financiera para evaluar la viabilidad de proyectos y la salud económica del negocio.`,
            },
        ]
    },
    {
        category: "Gestión Administrativa",
        icon: <FiBarChart2 size={22} />,
        items: [
            {
                title: "Nóminas y Obligaciones Laborales",
                content: `Cálculo de nóminas, gestión de pagos y cumplimiento de obligaciones ante el IVSS, INCES, y otros entes laborales.`,
            },
            {
                title: "Reportes Gerenciales y Estados Financieros",
                content: `Elaboración de reportes claros y concisos para la alta dirección, facilitando la comprensión del desempeño financiero.`,
            },
        ]
    },
];

// 🛑 ELIMINAMOS setActivePage de las props
const ContabilidadFinanzasPage = () => {
    const navigate = useNavigate(); // ✅ Inicializamos useNavigate

    return (
        <div className="page-container contabilidad-page">
            <header className="contabilidad-header">
                <FiDollarSign size={40} className="contabilidad-icon" />
                <h1>Servicios de Contabilidad y Finanzas</h1>
                <p className="contabilidad-summary">
                    Proporcionamos una gestión contable y financiera integral para su negocio en Venezuela. Desde la llevanza de libros y declaraciones de impuestos, hasta la planificación tributaria y la auditoría, aseguramos la salud y el cumplimiento fiscal de su empresa.
                </p>
                
                <div className="cta-box">
                    <p>¿Necesita optimizar sus finanzas y asegurar el cumplimiento fiscal?</p>
                    <button 
                        className="cta-button primary"
                        onClick={() => window.open('https://wa.me/14078738172?text=Quisiera%20asesor%C3%ADa%20en%20Contabilidad%20y%20Finanzas.', '_blank')}
                    >
                        Solicitar Asesoría Financiera
                    </button>
                </div>
            </header>

            <h2 className="section-title">Nuestra Cartera de Servicios Contables</h2>
            
            <div className="accordion-container">
                {CONTABILIDAD_FINANZAS_SECTIONS.map((section, index) => (
                    <div key={index} className="accordion-section-group">
                        <h3 className="section-group-title">
                            {section.icon} {section.category}
                        </h3>
                        {section.items.map((item, i) => (
                            <AccordionItem key={i} title={item.title}>
                                <p>{item.content}</p>
                            </AccordionItem>
                        ))}
                    </div>
                ))}
            </div>

            <footer className="footer-note">
                <p className="note-text">
                    <span className="note-bold">Garantía:</span> Transparencia, precisión y cumplimiento de las Normas Internacionales de Información Financiera (NIIF) y la legislación venezolana.
                </p>
            </footer>

            {/* 🚀 BOTÓN "Volver a Servicios" CORREGIDO */}
            <button className="back-button" onClick={() => navigate('/servicios')}>
                <FiArrowLeft /> Volver a Servicios
            </button>
        </div>
    );
};

export default ContabilidadFinanzasPage;